import { useLocation, useNavigate, useParams } from "react-router-dom";
import { OrderSummaryMain } from "../OrderSummary/OrderSummaryMain";
import { OrderDetailMain } from "./orderDetailMain";
import { GreetingContainer } from "./greetingContainer";
import { useAuth } from "../../Context/AuthContext";
import { Fragment, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../Context/pleaseNote";
import { Link } from "react-router-dom";
import { OrderConfirmationSkeleton } from "../../Skeleton/orderConfirmationSkeleton";
import { scrollToTop } from "../../Layout/Common/common";
import { useFeedback } from "../../Context/FeedbackContext";
import { useTillReturnSettlement } from "../../Context/hook/useTillReturnSettlement";
import { TillSettlingOverlay } from "../../Layout/Common/tillSettlingOverlay";
import { useTillReturnBackGuard } from "../../Context/hook/useTillReturnBackGuard";
import { readTillBackPath } from "../../Context/hook/tillRedirect";
import { PAGES } from "../../routeConfig";

const PAID_CART_RECHECK_MS = 4000;
const PAID_CART_RECHECK_LIMIT = 10;

export const BillInfoMain = () => {
  const { orderId } = useParams();
  const { settling, tillReturn } = useTillReturnSettlement();
  const { userId } = useAuth();

  useTillReturnBackGuard({
    active: !!tillReturn && !settling,
    backTo: readTillBackPath() || PAGES.HOME,
  });

  const [billInfo, setBillInfo] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { loadStoredCard, refreshCartItem } = useGlobalFunction();
  const { showFeedback } = useFeedback();
  const { showFlashScreen, showRestrictionAlert } = useNoteAlert();
  const histroy = useNavigate();
  const location = useLocation();
  const paymentData = location.state;

  const clearPaidOrderFromCart = async (paidOrderId, attempt = 0) => {
    const cart = await refreshCartItem();
    if (!paidOrderId || !cart || String(cart.orderid) !== String(paidOrderId)) return;
    globalcontext.setCartItem((prev) => ({
      ...prev,
      cartItem: [],
      totalItem: 0,
      totalcost: 0,
      subtotalcost: 0,
      shipcost: 0,
      totaltax: 0,
      totalIncTax: 0,
    }));
    if (attempt < PAID_CART_RECHECK_LIMIT) {
      setTimeout(() => clearPaidOrderFromCart(paidOrderId, attempt + 1), PAID_CART_RECHECK_MS);
    }
  };

  useEffect(() => {
    scrollToTop();
    showFlashScreen(false);
    if (settling) return;
    if (orderId) {
      axiosInstance
        .post("Payonline/GetBillInfo", {
          userId: String(userId),
          orderId: String(orderId),
        })
        .then((response) => {
          clearPaidOrderFromCart(response.data?.orderItem ? response.data.orderInfo?.OrderID : null);
          if (response.data && response.data.orderItem) {
            setBillInfo(response.data);
            setTimeout(() => {
              showFeedback({ source: "checkout", gated: true });
            }, 2000);
          } else {
            showRestrictionAlert({
              content: `<p class="text-center col-fs-14 fs-15 fw-normal">Invalid Order ID.</p>`,
              title: "Restricted Area",
              showCloseBtn: true,
              icon: "wes-address-home",
              crossButton: false,
              closeBtnFunction: () => {
                histroy("/home");
              },
            });
          }
        })
        .catch((error) => {
          console.log(error.message);
          refreshCartItem();
        });
      loadStoredCard();
    }
  }, [orderId, settling]);

  return (
    <Fragment>
      <TillSettlingOverlay show={settling} message="Confirming your payment..." />
      {!billInfo ? (
        <OrderConfirmationSkeleton />
      ) : (
        <Fragment>
          <section className="checkout-orderCompleted checkoutOrdercompleted">
            <div className="container-fluid container-lg">
              <div className="row">
                <GreetingContainer
                  reference={billInfo.poNumber}
                  orderStatus={billInfo.orderStatus}
                  isTBA={billInfo.isTBA}
                />
              </div>
            </div>
          </section>
          <section className="checkoutOrder-section checkoutOrderSection">
            <div className="container-fluid container-lg">
              <div className="row">
                <div className="col-md-8 offset-md-2 checkout-left">
                  <div className="row">
                    <OrderDetailMain billInfo={billInfo} />
                    <OrderSummaryMain billInfo={billInfo} />
                    <div className="col-lg-12 checkout-button">
                      <Link to="/myaccount/order-history" className="return-to-cart d-none d-md-block">
                        <i className="fa-solid fa-chevron-left" /> Go to My Orders
                      </Link>
                      <div className="button-effect">
                        <Link to="/home" className="btn btn-products btn-addcart">
                          Continue Shopping
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Fragment>
      )}
    </Fragment>
  );
};
